<template>
  <div>
    <div
      class="layout--text-button-wrap"
      :class="'credit-card__wrap ' + classes"
    >
      <p
        v-if="defaultCard"
        class="text-size-md-sm layout--flex-align-center layout--margin-bottom-sm"
      >
        <font-awesome-icon
          v-if="creditCardIcon"
          :icon="['fab', creditCardIcon]"
          class="text-size-lg-md layout--margin-right-xs"
        />
        {{ defaultCard.cardType }} ending in
        <strong class="layout--margin-left-xs layout--margin-right-md">{{
          defaultCard.lastFour
        }}</strong>
      </p>
      <div class="layout--flex-end">
        <button
          v-if="subscription.subscriptionType === 0 && defaultCard"
          type="button"
          class="button button--secondary layout--margin-bottom-sm layout--margin-right-sm"
          v-on:click="handleRemove"
        >
          Remove Credit Card
        </button>
        <button
          type="button"
          class="button layout--margin-bottom-sm"
          :class="{ 'button--secondary': secondary }"
          v-on:click="updateCreditCardModal"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
    <Error :invalid="removeError" :message="removeErrorMessage" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";

import { getCreditCardIcon } from "../helpers/helpers";

import UpdateCardModal from "./UpdateCardModal";
import Error from "./Error";

export default {
  name: "creditCard",
  components: {
    Error,
  },
  props: {
    buttonText: {
      type: String,
      default: "Edit Card Information",
    },
    classes: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    isAddCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      removeError: false,
      removeErrorMessage: "",
    };
  },
  computed: {
    ...mapGetters("account", ["defaultCard", "account", "subscription"]),
    creditCardIcon: function() {
      if (this.cardInUse && this.cardInUse.cardType) {
        return getCreditCardIcon(this.cardInUse.cardType);
      }
      return null;
    },
  },
  methods: {
    ...mapWaitingActions("account", {
      removeCreditCard: "removing credit card",
    }),
    handleRemove: function() {
      this.removeError = false;
      this.removeCreditCard(this.defaultCard.id).catch(error => {
        this.removeError = true;
        this.removeErrorMessage = error.response.data.message;
      });
    },
    updateCreditCardModal: function() {
      const isSuspended = this.account.suspended;
      const isAccountPage = this.$route.name === "plan and billing";

      this.$modal.show(UpdateCardModal, {
        suspendedMessage: isSuspended && isAccountPage,
      });
    },
  },
};
</script>

<style></style>
